const FlechaFebInverse = () => (
    <svg width="54" height="54" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd" d="M55.8643 17.0508C55.8643 11.528 51.3871 7.05084 45.8642 7.05084L8.13544 7.05084V46.9491C8.13544 52.472 12.6126 56.9491 18.1355 56.9491H55.8643V17.0508ZM49.8756 45.0114V15.1131H44.9804V44.8798H15.1289V49.7612H45.1124V45.0114H49.8756ZM42.2358 38.5598L21.0343 17.4185L17.5728 20.8701L38.7743 42.0114L42.2358 38.5598Z" fill="#26D07C" />
    </svg>

);

export default FlechaFebInverse;